module.exports = "img/flags/NU.9a77dd2.png";